var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('events-sheets-layout', {
    attrs: {
      "loading": _vm.loading
    },
    scopedSlots: _vm._u([{
      key: "body-items",
      fn: function () {
        return _vm._l(_vm.sheets, function (sheet) {
          return _c('card', {
            key: sheet.id,
            attrs: {
              "item": sheet
            },
            on: {
              "click": function ($event) {
                return _vm.onClick(sheet.token);
              }
            }
          });
        });
      },
      proxy: true
    }])
  });

}
var staticRenderFns = []

export { render, staticRenderFns }